(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-root]').forEach(productRoot => {
      if (productRoot.dataset.initialized) return;
      productRoot.dataset.initialized = 'true';
      const variantSelect = productRoot.querySelector('[data-variant-id]');
      const enhanced = productRoot.querySelector('[data-enhanced-options]');
      const optionSelects = [...productRoot.querySelectorAll('[data-option-index]')];
      const price = productRoot.querySelector('[data-product-price]');
      const compare = productRoot.querySelector('[data-compare-price]');
      const button = productRoot.querySelector('[data-add-button]');
      const status = productRoot.querySelector('[data-product-status]');
      const quantity = productRoot.querySelector('[name="quantity"]');
      const form = productRoot.querySelector('.product-form');
      const requiresPersonalization = productRoot.dataset.vacationPersonalized === 'true';
      const vacationFields = form.querySelector('[data-vacation-fields]');
      let personalizationReady = !requiresPersonalization;
      function setNeedByMinimum() {
        const field = vacationFields?.querySelector('[data-vacation-need-by]');
        if (!field) return;
        const today = new Date();
        field.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
      }
      if (requiresPersonalization) {
        const requiredNames = ['Family / group name', 'Destination', 'Date or year', 'Need-by date', 'Proof acknowledgment'];
        personalizationReady = Boolean(vacationFields) && requiredNames.every(name => {
          const input = form.elements.namedItem(`properties[${name}]`);
          return input && input.required && !input.disabled && vacationFields.contains(input);
        });
        form.noValidate = false;
        setNeedByMinimum();
        form.addEventListener('submit', event => {
          if (!personalizationReady) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          setNeedByMinimum();
          vacationFields.querySelectorAll('input[type="text"], textarea').forEach(input => { input.value = input.value.trim(); });
          if (!form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        window.addEventListener('pageshow', setNeedByMinimum);
      }
      const defaultImage = productRoot.querySelector('[data-main-image]');
      const defaultSrc = productRoot.dataset.defaultImage || defaultImage?.currentSrc || defaultImage?.src;
      const defaultAlt = productRoot.dataset.defaultAlt || defaultImage?.alt;
      let variants;
      try { variants = JSON.parse(productRoot.querySelector('[data-variants]').textContent); } catch { return; }
      function setImage(url, alt) {
        const img = productRoot.querySelector('[data-main-image]');
        if (!img || !url) return;
        img.src = url; img.removeAttribute('srcset'); img.removeAttribute('sizes');
        if (alt) img.alt = alt;
      }
      function update(variant, changeUrl = true) {
        if (!variant) { button.disabled = true; button.textContent = 'Unavailable'; status.textContent = 'This combination of options is not available.'; variantSelect.value = ''; return; }
        variantSelect.value = String(variant.id);
        price.textContent = variant.price;
        compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
        button.disabled = !variant.available || !personalizationReady; button.textContent = variant.available ? 'Add to bag' : 'Sold out';
        status.textContent = variant.available ? 'Available to order.' : 'This option is currently sold out.';
        quantity.min = variant.min; quantity.step = variant.step;
        if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
        let count = Number(quantity.value) || variant.min;
        count = Math.max(variant.min, variant.min + Math.floor((count - variant.min) / variant.step) * variant.step);
        if (variant.max != null) count = Math.min(count, variant.max);
        quantity.value = count;
        setImage(variant.image || defaultSrc, variant.image ? variant.alt : defaultAlt);
        if (changeUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); window.history.replaceState({}, '', url); }
      }
      const initial = variants.find(v => String(v.id) === variantSelect.value);
      if (enhanced && optionSelects.length) {
        if (initial) optionSelects.forEach((select, index) => { select.value = initial.options[index]; });
        enhanced.hidden = false;
        productRoot.querySelector('[data-variant-fallback]').hidden = true;
        optionSelects.forEach(select => select.addEventListener('change', () => update(variants.find(v => v.options.every((value, index) => value === optionSelects[index].value)))));
      }
      variantSelect.addEventListener('change', () => update(variants.find(v => String(v.id) === variantSelect.value)));
      if (initial) update(initial, false);
      productRoot.querySelectorAll('[data-image-url]').forEach(thumb => thumb.addEventListener('click', () => setImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt)));
      form.addEventListener('submit', event => {
        const current = variants.find(v => String(v.id) === variantSelect.value);
        if (!current || !current.available) { event.preventDefault(); return; }
        if (productRoot.dataset.submitting === 'true') { event.preventDefault(); return; }
        productRoot.dataset.submitting = 'true';
        button.textContent = 'Adding…';
      });
    });
    root.querySelectorAll('[data-save-product]').forEach(button => {
      if (button.dataset.initialized) return;
      const key = 'ivy-saved-products-v1';
      const note = button.nextElementSibling;
      try { const raw = JSON.parse(localStorage.getItem(key) || '[]'); if (!Array.isArray(raw)) throw new Error('Invalid saved items'); } catch { return; }
      const read = () => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(v => typeof v === 'string') : []; } catch { return []; } };
      const render = () => { const saved = read().includes(button.dataset.saveProduct); button.setAttribute('aria-pressed', String(saved)); button.textContent = saved ? '♥ Saved — tap to remove' : '♡ Save this item'; };
      button.dataset.initialized = 'true'; button.hidden = false; note.hidden = false; render();
      button.addEventListener('click', () => { const saved = read(); const handle = button.dataset.saveProduct; try { localStorage.setItem(key, JSON.stringify(saved.includes(handle) ? saved.filter(value => value !== handle) : [...saved, handle])); render(); } catch { note.textContent = 'Your browser couldn’t save this item. Try bookmarking this page.'; } });
    });
  }

  async function loadSaved() {
    const list = document.querySelector('[data-saved-list]');
    if (!list || list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const status = document.querySelector('[data-saved-status]');
    const base = (list.dataset.rootUrl || '/').replace(/\/$/, '');
    let handles;
    try { const value = JSON.parse(localStorage.getItem('ivy-saved-products-v1') || '[]'); if (!Array.isArray(value)) throw new Error(); handles = [...new Set(value.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)))].slice(0,100); }
    catch { status.textContent = 'Your browser could not read saved items. You can still bookmark any product page.'; return; }
    if (!handles.length) { status.textContent = 'No favorites saved yet. Tap “Save this item” on a product you love.'; return; }
    let imageRules = new Map();
    try {
      const ruleText = JSON.parse(document.querySelector('[data-hidden-product-images]')?.textContent || '""');
      imageRules = new Map(ruleText.split('|').filter(Boolean).map(rule => {
        const [handle, filenames] = rule.split('::');
        return [handle, new Set(filenames.split(','))];
      }));
    } catch { /* Products without image exclusions keep their native cover. */ }
    const visibleSavedImage = (handle, product) => {
      const hidden = imageRules.get(handle) || new Set();
      return [product.featured_image, ...(product.images || [])].find(src =>
        typeof src === 'string' && src && !hidden.has(src.split('?')[0].split('/').pop())
      );
    };
    let failed = 0;
    const results = [];
    for (let index = 0; index < handles.length; index += 6) {
      results.push(...await Promise.all(handles.slice(index,index+6).map(async handle => {
        try { const response = await fetch(`${base}/products/${encodeURIComponent(handle)}.js`); if (!response.ok) throw new Error(); return {handle, product: await response.json()}; }
        catch { failed++; return null; }
      })));
    }
    for (const result of results.filter(Boolean)) {
      const {handle,product} = result;
      const card = document.createElement('article'); card.className = 'product-card';
      const link = document.createElement('a'); link.className = 'product-image'; link.href = `${base}/products/${encodeURIComponent(handle)}`;
      const featuredImage = visibleSavedImage(handle, product);
      if (featuredImage) { try { const url = new URL(featuredImage,location.origin); if (url.protocol === 'https:' || url.origin === location.origin) { const img=document.createElement('img'); img.src=url.href; img.alt=product.title; img.loading='lazy'; img.width=600; img.height=600; link.append(img); } } catch {} }
      card.append(link);
      const meta=document.createElement('div'); meta.className='product-meta';
      const title=document.createElement('h3'); const titleLink=document.createElement('a'); titleLink.href=link.href; titleLink.textContent=product.title; title.append(titleLink); meta.append(title); card.append(meta);
      const remove=document.createElement('button'); remove.type='button'; remove.textContent='Remove favorite'; remove.setAttribute('aria-label',`Remove ${product.title} from favorites`);
      remove.addEventListener('click',()=>{try {const stored=JSON.parse(localStorage.getItem('ivy-saved-products-v1')||'[]'); localStorage.setItem('ivy-saved-products-v1',JSON.stringify(stored.filter(v=>v!==handle))); card.remove(); if (!list.children.length) status.textContent='No favorites saved yet.';}catch{status.textContent='Your browser couldn’t update saved items.';}});
      card.append(remove); list.append(card);
    }
    status.textContent = failed ? `${list.children.length} saved items shown. ${failed} could not be loaded; they remain saved for another visit.` : `${list.children.length} saved favorites.`;
  }
  init();
  loadSaved();
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-product-root]').forEach(root => { delete root.dataset.submitting; const button=root.querySelector('[data-add-button]'); if (button && button.textContent==='Adding…') button.textContent='Add to bag'; }));

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open], .desktop-dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  document.addEventListener('click', event => { document.querySelectorAll('.mobile-menu[open], .desktop-dropdown[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
})();
